<i18n>
{
    "ru": {
        "public_offer_tooltip": "PDF или HTML-файл",
        "invalid_file_type": "Неверный формат файла",
        "invalid_file_size": "Размер файла не должен превышать 2 Мб",
        "cannot_upload_file": "Не удалось загрузить файл",
        "cannot_remove_file": "Не удалось удалить файл"
    },
    "en": {
        "public_offer_tooltip": "PDF or HTML-file",
        "invalid_file_type": "Invalid file type",
        "invalid_file_size": "File size should not be greater than 2 MB",
        "cannot_upload_file": "Cannot upload file",
        "cannot_remove_file": "Cannot remove file"
    }
}
</i18n>

<template>
    <el-upload
        v-model="fileValue"
        :file-list="publicOfferFileList"
        ref="public_offer_file_ru"
        name="public_offer_file"
        class="upload-public-offer"
        accept="text/html, application/pdf"
        :headers="headers"
        :on-change="onChange"
        :on-exceed="onExceed"
        :on-remove="onRemove"
        :on-preview="onPreview"
        :on-error="onError"
        :action="`${billingUrl}/billing/public-offer/upload/${ this.billing_id }/${ this.lang }`"
        :limit="1">
        <el-button type="primary">{{ $t('upload') }}</el-button>
        <template #tip>
            <div class="el-upload__tip">
                {{ $t('public_offer_tooltip') }}
            </div>
        </template>
    </el-upload>
</template>

<script>
export default {
    name: 'upload-public-offer',

    props: {
        billing_id: {
            type: Number
        },
        lang: {
            type: String
        },
        value: {
            type: String
        }
    },

    computed: {
        fileValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('update:value', val)
            }
        }
    },

    data() {
        return {
            billingUrl: process.env.VUE_APP_BILLING_API_URL,
            headers: {
                'Authorization': `Bearer ${window.localStorage.getItem('jwt_token')}`
            },
            publicOfferFileList: []
        }
    },

    created() {
        if (this.value && this.value.length) {
            this.publicOfferFileList = [{
                name: this.value,
                url: this.billingUrl + '/billing/public-offer/' + this.billing_id + '/' + this.lang
            }]
        }
    },

    methods: {
        onChange(uploadFile, uploadFiles) {
            if (!this.validateFile(uploadFile.raw)) {
                uploadFiles.pop()
                return false
            }
            uploadFile.url = this.billingUrl + '/billing/public-offer/' + this.billing_id + '/' + this.lang

            return true
        },

        onExceed(uploadFiles) {
            if (!this.validateFile(uploadFiles[0])) {
                return false
            }

            const elUpload = this.$refs['public_offer_file_' + this.lang]

            elUpload.clearFiles()
            elUpload.handleStart(uploadFiles[0])
            elUpload.submit()
        },

        validateFile(file) {
            // Type
            if (file.type !== 'text/html' && file.type !== 'application/pdf') {
                this.$notify.error({ message: this.$t('invalid_file_type') })
                return false
            }
            // Size
            if (file.size > 2 * 1024 * 1024) {
                this.$notify.error({ message: this.$t('invalid_file_size') })
                return false
            }

            return true
        },

        async onRemove() {
            this.loading = true

            const response = await fetch(this.billingUrl + '/billing/public-offer/remove/' + this.billing_id + '/' + this.lang, {
                method: 'POST',
                headers: this.headers
            })
            const data = await response.json()
            this.loading = false

            if (!response.ok || response.status !== 200 || data.body.success !== true) {
                this.$notify.error({ message: this.$t('cannot_remove_file') })
                return false
            }

            return true
        },

        async onPreview(uploadFile) {
            await fetch(uploadFile.url, {
                method: 'GET',
                headers: this.headers
            })
                .then((response) => response.blob())
                .then(blob => {
                    const link = document.createElement('a')

                    link.target = '_blank'
                    link.href = URL.createObjectURL(blob)
                    link.click()

                    URL.revokeObjectURL(link.href)
                })
        },

        onError() {
            this.$notify.error({ message: this.$t('cannot_upload_file') })
        }
    }
}
</script>
